import { OrganizerSettings } from '@deltager/organizers/admin/shared/models/OrganizerSettings';
import { UserData } from '@deltager/organizers/admin/shared/models/LoginData';
import {
  UserBookingReportPredefined
} from '@deltager/organizers/admin/modules/booking-report/models/user-booking-report-predefined.model';

export enum ResolverKeys {
  OrganizerSettings = 'organizerSettings',
  UserData = 'userData',
  UserBookingReportPredefined = 'userPredefined',
}

export interface ResolverDataMap {
  [ResolverKeys.OrganizerSettings]: OrganizerSettings;
  [ResolverKeys.UserData]: UserData;
  [ResolverKeys.UserBookingReportPredefined]: UserBookingReportPredefined;
}

export type ResolverData = Partial<ResolverDataMap>;
